<div class="events-page">
  <!-- Top Bar -->
   <app-navbar page="events"></app-navbar>




  <!-- Main Content -->
  <div class="events-container">
    <div class="events-content">
      <!-- Header -->
      <div class="header">
        <h1 class="title">Upcoming & Past Events</h1>
        <button
          *ngIf="isSystemAdmin"
          mat-raised-button
          color="primary"
          class="add-button"
          (click)="openAddDialog()">
          <mat-icon>add</mat-icon>
          Add New Event
        </button>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Loading events...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="isError" class="error-container">
        <mat-icon color="warn">error</mat-icon>
        <p>Error loading events: {{ errorMessage }}</p>
      </div>

      <!-- Events List -->
      <div *ngIf="!isLoading && !isError">
        <!-- Upcoming Events -->
        <div class="divider">
          <span class="divider-text">UPCOMING</span>
        </div>

        <div *ngIf="upcomingEvents.length > 0" class="events-grid">
          <app-event-card
            *ngFor="let event of upcomingEvents"
            [event]="event"
            (viewDetails)="openEventDetails(event)">
          </app-event-card>
        </div>

        <div *ngIf="upcomingEvents.length === 0" class="no-events">
          <p>No upcoming events found.</p>
        </div>

        <!-- Past Events -->
        <div class="divider">
          <span class="divider-text">PAST</span>
        </div>

        <div *ngIf="pastEvents.length > 0" class="events-grid">
          <app-event-card
            *ngFor="let event of pastEvents"
            [event]="event"
            (viewDetails)="openEventDetails(event)">
          </app-event-card>
        </div>

        <div *ngIf="pastEvents.length === 0" class="no-events">
          <p>No past events found.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
   <app-footer></app-footer>

  <!-- Copyright Bar -->

</div>
